import { useState, useEffect, useRef } from 'react';
import Box from '../../lib/appfuse-react/component/Box';
import { makeStyles } from '@material-ui/core/styles';
import { ImageDialog } from './components';

// Convert original coordinates to percentage
const toPercent = (value, base) => `${(value / base) * 100}%`;

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    height: '100%',
    overflow: 'auto',
    backgroundColor: '#ffffff',
  },
  imageContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
  },
  imageWrapper: {
    position: 'relative',
    width: '100%',
  },
  image: {
    width: '100%',
    height: 'auto',
    display: 'block',
  },
  overlayButton: {
    position: 'absolute',
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer',
  },
  expandMenu: {
    position: 'absolute',
    zIndex: 10,
    cursor: 'pointer',
    '& img': {
      width: '100%',
      height: 'auto',
      display: 'block',
    },
  },
}));

// DM images with their dimensions and buttons
// Each image has its own coordinate system based on original dimensions
const DM_IMAGES = [
  {
    src: 'image/2026/main/main_1.png',
    id: 'cover',
    alt: 'Campus recruitment DM - Cover',
    width: 2251,
    height: 3177,
    anchors: [
      { id: 'departments', y: 1900 }, // Department buttons start position
    ],
    buttons: [
      { no: 1, x: 220, y: 2030, width: 600, height: 180, action: 'scroll', targetId: 'about' },
      { no: 2, x: 220, y: 2320, width: 600, height: 180, action: 'scroll', targetId: 'benefits' },
      {
        no: 'D1',
        x: 1130, y: 2180, width: 930, height: 110,
        action: 'expand',
        expandImage: 'image/2026/department_1/department_1_list/department_1_list.png',
        expandImageWidth: 952,
        expandImageHeight: 780,
        menuButtons: [
          { no: 'D11', x: 12, y: 108, width: 895, height: 100, action: 'dialog', dialogImage: 'image/2026/department_1/department_1_1.png' },
          { no: 'D12', x: 12, y: 210, width: 895, height: 75, action: 'dialog', dialogImage: 'image/2026/department_1/department_1_2.png' },
          { no: 'D13', x: 12, y: 290, width: 895, height: 75, action: 'dialog', dialogImage: 'image/2026/department_1/department_1_3.png' },
          { no: 'D14', x: 12, y: 370, width: 895, height: 75, action: 'dialog', dialogImage: 'image/2026/department_1/department_1_4.png' },
          { no: 'D15', x: 12, y: 450, width: 895, height: 75, action: 'dialog', dialogImage: 'image/2026/department_1/department_1_5.png' },
          { no: 'D16', x: 12, y: 530, width: 895, height: 85, action: 'dialog', dialogImage: 'image/2026/department_1/department_1_6.png' },
          { no: 'D17', x: 12, y: 615, width: 895, height: 95, action: 'dialog', dialogImage: 'image/2026/department_1/department_1_7.png' },
        ],
      },
      {
        no: 'D2',
        x: 1130, y: 2300, width: 930, height: 110,
        action: 'expand',
        expandImage: 'image/2026/department_2/department_2_list/department_2_list.png',
        expandImageWidth: 952,
        expandImageHeight: 416,
        menuButtons: [
          { no: 'D21', x: 12, y: 108, width: 895, height: 100, action: 'dialog', dialogImage: 'image/2026/department_2/department_2_1.png', borderColor: 'blue' },
          { no: 'D22', x: 12, y: 210, width: 895, height: 75, action: 'dialog', dialogImage: 'image/2026/department_2/department_2_2.png' },
          { no: 'D23', x: 12, y: 285, width: 895, height: 85, action: 'dialog', dialogImage: 'image/2026/department_2/department_2_3.png', borderColor: 'blue' },
        ],
      },
      { no: 'D3', x: 1130, y: 2420, width: 930, height: 110, action: 'dialog', dialogImage: 'image/2026/department_3/department_3.png' },
      { no: 'D4', x: 1130, y: 2540, width: 930, height: 110, action: 'dialog', dialogImage: 'image/2026/department_4/department_4.png' },
      { no: 'D5', x: 1130, y: 2660, width: 930, height: 110, action: 'dialog', dialogImage: 'image/2026/department_5/department_5.png' },
      {
        no: 'D6',
        x: 1130, y: 2780, width: 930, height: 110,
        action: 'expand',
        expandDirection: 'up',
        expandImage: 'image/2026/department_6/department_6_list/department_6_list.png',
        expandImageWidth: 952,
        expandImageHeight: 416,
        menuButtons: [
          { no: 'D61', x: 12, y: 108, width: 895, height: 95, action: 'dialog', dialogImage: 'image/2026/department_6/department_6_1.png' },
          { no: 'D62', x: 12, y: 205, width: 895, height: 85, action: 'dialog', dialogImage: 'image/2026/department_6/department_6_2.png', borderColor: 'blue' },
          { no: 'D63', x: 12, y: 290, width: 895, height: 85, action: 'dialog', dialogImage: 'image/2026/department_6/department_6_3.png' },
        ],
      },
    ],
  },
  {
    src: 'image/2026/main/main_2.png',
    id: 'about',
    alt: 'Campus recruitment DM - About CTCI',
    width: 2250,
    height: 3177,
    buttons: [
      { no: 4, x: 1850, y: 2980, width: 180, height: 110, action: 'scroll', targetId: 'departments' },
    ],
  },
  {
    src: 'image/2026/main/main_3.png',
    id: 'benefits',
    alt: 'Campus recruitment DM - Compensation & Benefits',
    width: 2250,
    height: 3177,
    buttons: [
      { no: 5, x: 1850, y: 2980, width: 180, height: 110, action: 'scroll', targetId: 'departments' },
    ],
  },
  {
    src: 'image/2026/main/main_4.png',
    id: null,
    alt: 'Campus recruitment DM - Footer',
    width: 2250,
    height: 369,
    buttons: [],
  },
];

function CampusDM() {
  const classes = useStyles();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogImage, setDialogImage] = useState(null);
  const [expandedButton, setExpandedButton] = useState(null);
  const expandMenuRef = useRef(null);
  const expandButtonRef = useRef(null);

  // Set document title on mount
  useEffect(() => {
    document.title = '中鼎工程介紹';
  }, []);

  // Clickaway listener for expand menu
  useEffect(() => {
    if (!expandedButton) return;

    const handleClickAway = (event) => {
      // Check if click is outside menu and outside the button that triggered it
      const isOutsideMenu = expandMenuRef.current && !expandMenuRef.current.contains(event.target);
      const isOutsideButton = expandButtonRef.current && !expandButtonRef.current.contains(event.target);

      if (isOutsideMenu && isOutsideButton) {
        setExpandedButton(null);
      }
    };

    document.addEventListener('mousedown', handleClickAway);
    return () => {
      document.removeEventListener('mousedown', handleClickAway);
    };
  }, [expandedButton]);

  const handleScrollTo = (targetId) => {
    const element = document.getElementById(targetId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleButtonClick = (btn, imageWidth, imageHeight) => {
    if (btn.action === 'dialog') {
      setDialogImage(btn.dialogImage);
      setDialogOpen(true);
      setExpandedButton(null);
    } else if (btn.action === 'expand') {
      // Toggle expand menu
      if (expandedButton?.no === btn.no) {
        setExpandedButton(null);
      } else {
        setExpandedButton({ ...btn, imageWidth, imageHeight });
      }
    } else if (btn.action === 'scroll') {
      handleScrollTo(btn.targetId);
      setExpandedButton(null);
    }
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
    setDialogImage(null);
  };

  return (
    <Box className={classes.root}>
      <div className={classes.imageContainer}>
        {DM_IMAGES.map((image, index) => (
          <div key={index} className={classes.imageWrapper}>
            <img
              id={image.id}
              src={image.src}
              alt={image.alt}
              className={classes.image}
            />
            {/* Anchor points for scroll navigation */}
            {image.anchors?.map((anchor) => (
              <div
                key={anchor.id}
                id={anchor.id}
                style={{
                  position: 'absolute',
                  top: toPercent(anchor.y, image.height),
                  left: 0,
                  height: 0,
                  width: 0,
                }}
              />
            ))}
            {image.buttons?.map((btn, btnIndex) => (
              <button
                key={btnIndex}
                ref={expandedButton?.no === btn.no ? expandButtonRef : null}
                className={classes.overlayButton}
                style={{
                  left: toPercent(btn.x, image.width),
                  top: toPercent(btn.y, image.height),
                  width: toPercent(btn.width, image.width),
                  height: toPercent(btn.height, image.height),
                }}
                onClick={() => handleButtonClick(btn, image.width, image.height)}
                aria-label={btn.action === 'dialog' ? 'Open dialog' : btn.action === 'expand' ? 'Expand menu' : `Go to ${btn.targetId}`}
              />
            ))}
            {/* Expand menu */}
            {expandedButton && image.buttons?.some(btn => btn.no === expandedButton.no) && (() => {
              const menuScaledHeight = expandedButton.expandImageHeight * (expandedButton.width / expandedButton.expandImageWidth);
              const menuTop = expandedButton.expandDirection === 'up'
                ? expandedButton.y - menuScaledHeight
                : expandedButton.y + expandedButton.height;
              return (
              <div
                ref={expandMenuRef}
                className={classes.expandMenu}
                style={{
                  left: toPercent(expandedButton.x, expandedButton.imageWidth),
                  top: toPercent(menuTop, expandedButton.imageHeight),
                  width: toPercent(expandedButton.width, expandedButton.imageWidth),
                }}
              >
                <img src={expandedButton.expandImage} alt="Expand menu" />
                {/* Menu buttons */}
                {expandedButton.menuButtons?.map((menuBtn, menuBtnIndex) => (
                  <button
                    key={menuBtnIndex}
                    className={classes.overlayButton}
                    style={{
                      left: toPercent(menuBtn.x, expandedButton.expandImageWidth),
                      top: toPercent(menuBtn.y, expandedButton.expandImageHeight),
                      width: toPercent(menuBtn.width, expandedButton.expandImageWidth),
                      height: toPercent(menuBtn.height, expandedButton.expandImageHeight),
                      ...(menuBtn.borderColor && { borderColor: menuBtn.borderColor }),
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleButtonClick(menuBtn, expandedButton.expandImageWidth, expandedButton.expandImageHeight);
                    }}
                    aria-label={`Menu item ${menuBtn.no}`}
                  />
                ))}
              </div>
              );
            })()}
          </div>
        ))}
      </div>

      <ImageDialog
        open={dialogOpen}
        imageSrc={dialogImage}
        onClose={handleDialogClose}
      />
    </Box>
  );
}

export default CampusDM;
